import { ICandidateReferenceProspect, CandidateReferenceProspectModel } from "@core/models";

export class CandidateReferenceProspectDTO extends CandidateReferenceProspectModel {
  prepareReferenceProspectData() {
    return {
      manager_firstname: this[ICandidateReferenceProspect.firstname],
      manager_lastname: this[ICandidateReferenceProspect.lastname],
      manager_email: this[ICandidateReferenceProspect.email] ? this[ICandidateReferenceProspect.email] : "",
      manager_comment: this[ICandidateReferenceProspect.comment],
      manager_rating: this[ICandidateReferenceProspect.rating],
      manager_phone_number: this[ICandidateReferenceProspect.phoneNumber] ? this[ICandidateReferenceProspect.phoneNumber] : "",
    };
  }
}
